import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/equipmentLive/nothing.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1f6cd284"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "equipment-live-list"
};
var _hoisted_2 = {
  key: 1,
  class: "nothing"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "暂无数据", -1);
});
var _hoisted_5 = [_hoisted_3, _hoisted_4];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_device_list_item = _resolveComponent("device-list-item");
  var _component_Loading = _resolveComponent("Loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [!_ctx.showLoading ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_ctx.list2.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.list2, function (item, index) {
    return _openBlock(), _createBlock(_component_device_list_item, {
      key: item.deviceId,
      item: item,
      index: index,
      onUpdate: _ctx.updateDevice
    }, null, 8, ["item", "index", "onUpdate"]);
  }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))], 64)) : (_openBlock(), _createBlock(_component_Loading, {
    key: 1,
    size: "44",
    vertical: "",
    class: "show-loading",
    color: "#4372f6"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(" 加载中... ")];
    }),
    _: 1
  }))]);
}